export default __webpack_public_path__ + "static/media/guardofdancingsteel4.0a7da0c4.png";